import React from "react";
import { Redirect } from "react-router-dom";
import Header from "../../components/Header";
import Firebase from "../../firebasehelper";

import "./index.css";

import ecosystemTrial from "../../assets/media/ecosystem_trial.png";
import ecosystemGo from "../../assets/media/ecosystem_go.png";
import ecosystemPro from "../../assets/media/ecosystem_pro.png";
import { getEsignEmbbedUrl } from "../../api/UserApi";
import AddCommercialUserDialog from "./AddCommercialUserDialog";
import AddBusinessInfoDialog from "./AddBusinessInfoDialog";

const $ = window.$;

class UserPlatform extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      brand: null,
      logo: null,
      brand_name: null,
      is_property_brand: false,
      commericalUserId: null,
      agencies: [],
      registeredCompanyName: "",
      registeredCompanyID: "",
      registeredAddress: "",
    };
  }

  async componentDidMount() {
    if (!this.props.location.state) {
      this.props.history.push("/");
      return;
    }

    const { brand, role, username } = this.props.location.state;
    this.setState({ brand });

    Firebase.getBrandDataByID(brand, (brand_data) => {
      this.setState({
        logo: brand_data.logo,
        brand_name: brand_data.name,
        // inactiveBoltPackages: brand_data.inactiveBoltPackages || [],
        is_property_brand: brand_data.is_property_brand
          ? brand_data.is_property_brand
          : false,
        // territory: brand_data.territory || TerritoryOptions[0],
        commericalUserId: brand_data.commericalUserId,
        registeredCompanyName: brand_data.registeredCompanyName || "",
        registeredCompanyID: brand_data.registeredCompanyID || "",
        registeredAddress: brand_data.registeredAddress || "",
        contractStartDate: brand_data.contractStartDate,
        contractLength: brand_data.contractLength,
        trialSize: brand_data.trialSize || "",
        programme: brand_data.programme || {},
      });
      console.log("brand_data", brand_data);
    });

    Firebase.getAgencyByBrandID(brand, (res) => {
      console.log("agencies", res);
      this.setState({ agencies: res });
    });
  }

  toGoBrandAdmins = () => {
    const { username, role, brand } = this.props.location.state;
    this.props.history.push("/brand-admins", {
      username,
      role,
      brand,
    });
  };

  toGoBrandInfo = () => {
    const { username, role, brand } = this.props.location.state;
    this.props.history.push("/brand", {
      username,
      role,
      brand,
    });
  };

  onPricingPlan = (type) => async () => {
    if (type === "pro") return;
    const {
      commericalUserId,
      agencies,
      registeredCompanyName,
      registeredCompanyID,
      registeredAddress,
      brand_name,
      contractStartDate,
      programme,
      trialSize,
    } = this.state;
    const agency = agencies.find((obj) => obj.uid === commericalUserId);
    if (!agency) {
      $("#add_commercial_user").modal("show");
      return;
    }
    if (
      !contractStartDate ||
      !(
        programme &&
        programme.management_fee &&
        programme.management_fee.price
      ) ||
      !trialSize
    ) {
      $("#add_business_info_dialog").modal("show");
      return;
    }
    const esignUrl = await getEsignEmbbedUrl(
      agency.email,
      agency.username,
      "",
      registeredCompanyName,
      registeredCompanyID,
      registeredAddress,
      brand_name.replace(/\s/g, ""),
      contractStartDate,
      programme.management_fee.price,
      trialSize,
      type
    );
    const {
      embeddedSigningSessions: [session],
    } = esignUrl.data;
    window.open(session.embeddedSessionURL, "_blank");
  };

  render() {
    const { brand, brand_name, is_property_brand, logo } = this.state;
    if (!this.props.location.state) return <Redirect to="/" />;
    let username = this.props.location.state.username;
    let role = this.props.location.state.role;

    return (
      <div id="page-container">
        <Header
          username={username}
          role={role}
          logo={logo}
          brand={brand}
          brandName={brand_name}
          is_property_brand={is_property_brand}
        />
        <main id="main-container" className="channel-container">
          <div className="content">
            <div className="Div-Pricing-Plan mb-5">
              <div className="Div-Plan-Wrapper">
                <img className="Img-Plan mb-3" src={ecosystemTrial} />
                <p>a.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;4 week trial period.</p>
                <p>b.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;100 community users.</p>
                <p>c.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Training Workshop Huddle.</p>
                <p>d.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Weekly engage Hangouts.</p>
                <p>e.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Review Huddle.</p>
                <p>
                  &nbsp;f.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Trial features include:
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Gamification & token
                  earning
                </p>
                <p>&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EcoiD</p>
                <p>&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EcoWallet</p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EcoPay - Go & Pro
                  retailers
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EcoStore - List & sell
                  products
                </p>
                <p>&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Feeds, Polls & games</p>
                <p style={{ visibility: "hidden" }}>-</p>
                <p className="text-center mt-3">Fixed £100</p>
                <button
                  className="Button-Plan mt-3"
                  onClick={this.onPricingPlan("trial")}
                >
                  Get started.
                </button>
              </div>
              <div className="Div-Plan-Wrapper">
                <img className="Img-Plan mb-3" src={ecosystemGo} />
                <p>
                  a.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Go access to most Ecosystems.
                </p>
                <p>b.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Weekly engage Hangouts.</p>
                <p>c.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Monthly deep dive Huddle.</p>
                <p>d.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Features include.</p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dedicated campaign
                  manager.
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Gamification & token
                  earning
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EcoiD - Blockchain iD
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EcoAi - Open banking &
                  analytics
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EcoWallet - Tokens,
                  cards, spends
                </p>
                <p>&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bespoke tokens x 2</p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EcoPay - Go retailers
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;EcoStore - List & sell
                  products
                </p>
                <p>&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Feeds, Polls & games</p>
                <p className="text-center mt-3">25p-£1 per user per month</p>
                <button
                  className="Button-Plan mt-3"
                  onClick={this.onPricingPlan("go")}
                >
                  Activate.
                </button>
              </div>
              <div className="Div-Plan-Wrapper">
                <img className="Img-Plan mb-3" src={ecosystemPro} />
                <p>
                  a.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pro access to all Ecosystems.
                </p>
                <p>b.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Weekly engage Hangouts.</p>
                <p>c.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Monthly deep dive Huddle.</p>
                <p>d.&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Features include:</p>
                <p>&nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;All Go features</p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Full API & whitelabel
                  integration.
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dedicated data rack &
                  control.
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Pro retailers & offers
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;User token earning from
                  retailers.
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Taskers & user
                  interaction suite.
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Unlimited custom tokens.
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bespoke chatbot maker.
                </p>
                <p>
                  &nbsp;-&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Bespoke digital bank
                  cards.
                </p>
                <p className="text-center mt-3">Minimum 10,000 users.</p>
                <button
                  className="Button-Plan mt-3"
                  onClick={this.onPricingPlan("pro")}
                >
                  Apply.
                </button>
              </div>
            </div>
          </div>
        </main>
        <AddCommercialUserDialog goBrandAdmins={this.toGoBrandAdmins} />
        <AddBusinessInfoDialog goBrandInfo={this.toGoBrandInfo} />
      </div>
    );
  }
}
export default UserPlatform;



// WEBPACK FOOTER //
// ./src/screens/UserPlatform/index.js